var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { styled } from "@mui/material/styles";
import { Tabs as MuiTabs, Tab as MuiTab, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
var TabStyles = {
    Wrapper: styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        width: 100%;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\n        .MuiTabs-scroller {\n            margin-bottom: 10px;\n        }\n    "], ["\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        width: 100%;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\n        .MuiTabs-scroller {\n            margin-bottom: 10px;\n        }\n    "]))),
    Content: styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        box-sizing: border-box;\n        width: 100%;\n        padding: 2rem var(--2, 16px);\n    "], ["\n        box-sizing: border-box;\n        width: 100%;\n        padding: 2rem var(--2, 16px);\n    "]))),
};
export var Tabs = function (_a) {
    var elements = _a.elements, selectedTab = _a.selectedTab, onSelectedTabChange = _a.onSelectedTabChange, props = __rest(_a, ["elements", "selectedTab", "onSelectedTabChange"]);
    var t = useTranslation().t;
    var baseUrl = new URL(window.location.href);
    var _b = React.useState(function () {
        var _a, _b, _c;
        var tabId = (_a = baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.searchParams) === null || _a === void 0 ? void 0 : _a.get("tabId");
        var linked = tabId ? elements.findIndex(function (element) { return element.id === tabId; }) : -1;
        return linked >= 0 ? linked : Number.parseInt((_c = (_b = baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.searchParams) === null || _b === void 0 ? void 0 : _b.get("tabIndex")) !== null && _c !== void 0 ? _c : "0");
    }), internalSelectedTab = _b[0], setInternalSelectedTab = _b[1];
    var requestedTab = selectedTab !== null && selectedTab !== void 0 ? selectedTab : internalSelectedTab;
    var validSelection = Number.isInteger(requestedTab) && requestedTab >= 0 && requestedTab < elements.length;
    // Render the fallback immediately, including while a controlled parent updates.
    var activeTab = validSelection ? requestedTab : 0;
    var selectedElement = elements[activeTab];
    var handleChange = function (event, newValue) {
        setInternalSelectedTab(newValue);
        onSelectedTabChange === null || onSelectedTabChange === void 0 ? void 0 : onSelectedTabChange(newValue);
    };
    React.useEffect(function () {
        if (elements.length > 0 && !validSelection) {
            setInternalSelectedTab(0);
            onSelectedTabChange === null || onSelectedTabChange === void 0 ? void 0 : onSelectedTabChange(0);
        }
    }, [validSelection, elements.length, onSelectedTabChange]);
    var SelectedComponent = selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.component;
    return (_jsxs(TabStyles.Wrapper, { children: [_jsx(Box, { sx: {
                    width: "100%",
                    bgcolor: "background.paper",
                    borderBottom: 1,
                    borderColor: "divider",
                }, children: _jsx(MuiTabs, { variant: "scrollable", allowScrollButtonsMobile: true, scrollButtons: "auto", value: selectedElement ? activeTab : false, onChange: handleChange, indicatorColor: "primary", textColor: "primary", "aria-label": "disabled tabs example", children: elements.map(function (tab, index) { return (_jsx(MuiTab, { label: tab.label, onClick: function () { var _a, _b; return (_b = (_a = tab === null || tab === void 0 ? void 0 : tab.action) === null || _a === void 0 ? void 0 : _a.call(tab, index)) !== null && _b !== void 0 ? _b : null; } }, tab.label)); }) }) }), _jsx(TabStyles.Content, { children: _jsx(React.Suspense, { fallback: _jsx("div", { children: t("loading") }), children: SelectedComponent ? (_jsx(SelectedComponent, __assign({}, props, selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.props))) : null }) })] }));
};
var templateObject_1, templateObject_2;
